import {
  asBoolean,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { EventBundle } from "./event-bundle";

export class Ticket {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.publicTicket = asBoolean(json.publicTicket);
    this.paidEvent = asBoolean(json.paidEvent);
    this.paid = asBoolean(json.paid);
    this.mandatory = asBoolean(json.mandatory);
    this.decommission = asBoolean(json.decommission);
    this.ticketId = asString(json.ticketId);
    this.orgId = asString(json.orgId);
    this.orgName = asString(json.orgName);
    this.eventId = asString(json.eventId);
    this.eventName = asString(json.eventName);
    this.userId = asString(json.userId);
    this.userName = asString(json.userName);
    this.lastName = asString(json.lastName);
    this.firstName = asString(json.firstName);
    this.intCode = asString(json.intCode);
    this.phone = asString(json.phone);
    this.email = asString(json.email);
    this.transactionNo = asString(json.transactionNo);
    this.transactionId = asString(json.transactionId);
    this.amountPaid = asNumber(json.amountPaid);
    this.currency = asString(json.currency);
    this.status = asString(json.status);
    this.ticketNo = asString(json.ticketNo);
    this.userImage = asString(json.userImage);
    this.userVerified = asBoolean(json.userVerified);
    this.barCodeUrl = asString(json.barCodeUrl);
    this.tickets = parseList(json.tickets, EventBundle.fromJson);
  }

  get fullName() {
    return [this.firstName, this.lastName].filter(Boolean).join(" ");
  }

  get ticketNoDisplay() {
    return this.ticketNo ? `# ${this.ticketNo}` : "#";
  }

  get isPending() {
    return String(this.status || "").toLowerCase() === "pending";
  }

  static fromJson(json: any) {
    return isObject(json) ? new Ticket(json) : json;
  }
}
